import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * PDP Sale Code pill. Collection cards scan variants in Liquid; this element
 * only runs on product-information so the tag tracks the selected SKU.
 *
 * @typedef {Object} Refs
 * @property {HTMLElement} [saleCode]
 *
 * @extends {Component<Refs>}
 */
class SaleCodeComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * @param {Event & { promise?: Promise<{ detail?: { html?: Document, productId?: string, newProduct?: { id: string } } }> }} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    if (!event.promise) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const newComponent = html.querySelector(`sale-code-component[data-block-id="${this.dataset.blockId}"]`);
        if (!newComponent) return;

        const newSlot = newComponent.querySelector('[ref="saleCode"]');
        const currentSlot = this.refs.saleCode;
        if (newSlot && currentSlot) currentSlot.replaceWith(newSlot);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[sale-code] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('sale-code-component')) {
  customElements.define('sale-code-component', SaleCodeComponent);
}
